/**
 * Agrupamento por modulo do feature-module-picker, usado pela Liberacao
 * (opcoes com o enum, vindas do FeatureModuleCatalog) e pelo modal de
 * funcionalidades do boleto (opcoes com o id do banco, de GET_FEATURES).
 *
 * Cada opcao traz `module`, `moduleOrder` e `order`. Nome de modulo so aparece
 * escrito a mao no fallback 'Outras' de groupByModule, para a opcao que chegar
 * SEM modulo: sumir esconderia uma funcionalidade, entao ela cai em "Outras"
 * em vez de desaparecer.
 */

const byOrder = (a, b) => a.order - b.order;

const FALLBACK_MODULE = 'Outras';

/**
 * Chave estavel de cada modulo, para estado de tela (secao aberta/fechada):
 * o nome em portugues e rotulo e pode mudar de grafia; a chave nao. Modulo novo
 * sem entrada aqui usa o proprio nome como chave — duas secoes desconhecidas
 * nao podem dividir o mesmo estado.
 */
const MODULE_KEYS = {
  'Controle de Jornada': 'journey',
  'Departamento Pessoal': 'personalDepartment',
  'Desenvolvimento de Pessoas': 'peopleDevelopment',
  'Comunicação e Cultura': 'communicationCulture',
  'Benefícios Corporativos': 'corporateBenefits',
  'Extras': 'extras',
  [FALLBACK_MODULE]: 'others',
};

export const groupByModule = (options) => {
  const groups = {};

  (options || []).forEach((option) => {
    const key = option.module || FALLBACK_MODULE;
    if (!groups[key]) {
      groups[key] = { name: key, order: option.moduleOrder || 0, features: [] };
    }
    groups[key].features.push(option);
  });

  return Object.keys(groups)
    .map((key) => groups[key])
    .sort(byOrder)
    .map((group) => ({
      key: MODULE_KEYS[group.name] || group.name,
      name: group.name,
      order: group.order,
      features: group.features.slice().sort(byOrder),
    }));
};

/** Secoes abertas ao entrar: so a primeira, para a tela nao nascer com seis grades. */
export const initialOpenState = (groups) => {
  const open = {};
  (groups || []).forEach((group, index) => { open[group.key] = index === 0; });
  return open;
};

/** Quantas do modulo estao marcadas — o cabecalho mostra mesmo com a secao fechada. */
export const selectedCount = (selected, module) =>
  module.features.filter((feature) => selected.indexOf(feature.value) !== -1).length;

export const isModuleFullySelected = (selected, module) =>
  module.features.length > 0 &&
  module.features.every((feature) => selected.indexOf(feature.value) !== -1);

/** Completo -> esvazia o modulo; senao -> completa. Nunca toca nos outros. */
export const toggleModule = (selected, module) => {
  const values = module.features.map((feature) => feature.value);

  if (isModuleFullySelected(selected, module)) {
    return selected.filter((value) => values.indexOf(value) === -1);
  }

  return selected.concat(values.filter((value) => selected.indexOf(value) === -1));
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/default/featureModules.js